// extracted by mini-css-extract-plugin
module.exports = {"power-backup":"PowerBackup_power-backup__L0kjf"};